<script lang="ts">
  import { Router, Link, Route, navigate } from "svelte-navigator";
  import Cart from "./Cart.svelte";
  import Checkout from "./Checkout.svelte";
  import Header from "./Header.svelte";
  import { fade } from "svelte/transition";
  import { onMount } from "svelte";
  import Login from "./Login.svelte";
  import { StorageKeys } from "./enums/localStorageKeys";
  import { Views, accessToken, currentPage } from "./store";
  import Success from "./Success.svelte";
  import Toast from "./Toast.svelte";


  onMount(() => {
    // Todo: show thankyou-page on success
    loadToken();
  });

  function loadToken() {
    let expirationDate = Number(
      localStorage.getItem(StorageKeys.AccessTokenExpirationDate)
    );
    
    if (expirationDate < Date.now()) {
      console.log(expirationDate);
      localStorage.removeItem(StorageKeys.AccessToken);
      navigate("/", { replace: true });
    }
    accessToken.set(localStorage.getItem(StorageKeys.AccessToken));
  }
</script>

<main class="flex flex-col p-6 lg:p-0 h-full">
  <Router>
    <Header />
    <Route path="/">
        <Login />
    </Route>
    <div class="flex pt-12 justify-center">
      <Route path="success">
          <Success />
      </Route>
      <Route path="cart">
          <Cart />
      </Route>
      <Route path="checkout">
        <div class="w-96 max-w-full">
          <Checkout />
        </div>
      </Route>
    </div>

    <Toast />
  </Router>
</main>

<svelte:head>
  <base href="BASE_PATH" />
</svelte:head>

<style global>
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
</style>
